import React from "react";

const LEGEND_ITEMS = [
  {
    icon: "/icons/cursor_default.svg",
    key: "legendExact",
    fallback: "ADRESSE PRÉCISE",
  },
  {
    icon: "/icons/cursor_approximative.svg",
    key: "legendArea",
    fallback: "ZONE GÉOGRAPHIQUE",
  },
  {
    icon: "/icons/cursor_virtual.svg",
    key: "legendVirtual",
    fallback: "PROJET VIRTUEL",
  },
];

const MapLegend = ({ hidden, t }) => {
  if (hidden) return null;

  return (
    <div
      style={{
        position: "absolute",
        bottom: 24,
        right: 16,
        background: "rgba(255,255,255,0.95)",
        borderRadius: 8,
        padding: "10px 12px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
        border: "1px solid #e2e8f0",
        zIndex: 5,
        pointerEvents: "none",
      }}
    >
      {LEGEND_ITEMS.map((item) => {
        const label = (t && t(item.key)) || item.fallback;
        return (
          <div
            key={item.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 6,
            }}
          >
            <img
              src={item.icon}
              alt={label}
              style={{ height: 18, width: 18, objectFit: "contain" }}
            />
            <span
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#265b4f",
                letterSpacing: 0.4,
                textTransform: "uppercase",
              }}
            >
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MapLegend;
